import React, { PropTypes } from 'react';
import { Map } from 'immutable';
import throttle from 'lodash/function/throttle';
import SmartMenu from 'components/SmartMenu';
import GoalCard from 'components/GoalCard';
import Spinner from 'components/Spinner';
import GoalsSearch from 'components/GoalsSearch';
import GoalCardWrapper from 'components/GoalCard/Wrapper';

import Specials from './Specials';
import MostActive from './MostActive';
import MostDiscussed from './MostDiscussed';
import shallowEqual from 'react-pure-render/shallowEqual';
import connectToStores from 'decorators/connectToStores';
import withStyles from 'decorators/withStyles';
import cx from './GoalsPage.scss';
import needLoadSubscribe from 'utils/needLoadSubscribe';

const goalMenuItems = Map(__('goal.goal_menu'));
const templateMenuItems = Map(__('template.template_menu'));

const blocks = [
  ({ flux }) => <Specials flux={flux} />,
  ({ flux, usersTop }) => <MostActive flux={flux} initialData={usersTop} />,
  ({ flux, goalsTop }) => <MostDiscussed flux={flux} initialData={goalsTop} />,
];

@withStyles(cx)
@connectToStores({
  currency: ({ state }) => ({ currency: state }),
  categories: ({ state }) => ({ categories: state.categories }),
  goals: store => store.state,
  goalsList: store => ({
    loaded: store.state.loaded,
    loading: store.state.loading,
    items: store.state.items, // .getGoals(),
    filter: store.state.filter,
  }),
})
export default class GoalsPage extends React.Component {

  static propTypes = {
    showAdditionalBlocks: PropTypes.bool.isRequired,
    additionalBlocksPositions: PropTypes.array,
    loading: PropTypes.bool.isRequired,
    loaded: PropTypes.bool.isRequired,
    flux: PropTypes.object.isRequired,
    goals: PropTypes.object.isRequired,
    items: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    initFilter: PropTypes.object.isRequired,
    categories: PropTypes.object.isRequired,
    currency: PropTypes.object.isRequired,
    isGuest: PropTypes.bool,
    usersTop: PropTypes.array,
    goalsTop: PropTypes.array,
  };

  static defaultProps = {
    additionalBlocksPositions: [],
  };

  constructor() {
    super();
    this.handleNeedLoad = throttle(() => {
      if(!this.props.loaded) {
        this.props.flux.getActions('goalsList').loadPage(this.props.items.size);
      }
    }, 100);
  }

  componentWillMount() {
    needLoadSubscribe(this.handleNeedLoad);
    this.props.filter.lang = this.props.initFilter.lang;
  }

  componentWillReceiveProps(nextProps) {
    if(!shallowEqual(this.props.filter, nextProps.filter)) {
      const { section, sort } = nextProps.filter;
      const urlOptions = { section, sort };

      history.pushState(
        null, null,
        `${location.origin}${location.pathname}?${Object.keys(urlOptions).map(key => [key, urlOptions[key]].join('=')).join('&')}`
      );
    }
  }

  handleMenuClick(item) {
    const { flux, filter } = this.props;

    if(filter.section !== item && item !== 'groups') {
      flux.getActions('goalsList').changeFilter('section', item);
    }
  }

  render() {
    const { filter, flux, loading, categories } = this.props;
    const goalsListActions = flux.getActions('goalsList');

    return (
      <div>
        <SmartMenu
          onItemClick={(item, e) => {
            if(item !== 'groups') {
              e.preventDefault();
              this.handleMenuClick(item);
            }
          }}
          items={filter.list_type === 'goal' ? goalMenuItems : templateMenuItems}
          additionals={filter.list_type === 'goal' ? ['completed'] : []}
          urls={{
            groups: '/goalGroup',
            interesting: '/goal',
            all: '/goal?section=all',
            promise: '/goal?section=promise',
            completed: '/goal?section=completed',
          }}
          value={filter.section}
          />

        <div className="content container">
          <GoalsSearch
            filter={filter}
            loading={loading}
            categories={categories}
            onReset={goalsListActions.resetFilter}
            onChange={goalsListActions.changeFilter}
            />
          {this.renderList()}

          {loading &&
            <div style={{ textAlign: 'center' }}>
              <Spinner />
            </div>
          }
        </div>
      </div>
    );
  }

  renderList() {
    const { items, flux, showAdditionalBlocks, filter, isGuest, currency, additionalBlocksPositions } = this.props;
    const goals = items.map(id => this.props.goals.get(id));
    const goalsActions = flux.getActions('goals');
    const additionalBlocks = additionalBlocksPositions.reduce((memo, index, i) => ({
      ...memo,
      [index]: blocks[i],
    }), {});

    return (
      <div className={cx('list')}>
        {goals.map((goal, i) => [
          [
            (showAdditionalBlocks && filter.section === 'interesting' && additionalBlocks[i])
              && additionalBlocks[i](this.props),
            <GoalCard
              onLike={() => goalsActions.like(goal.get('id'), filter.list_type)}
              onSubscribe={() => goalsActions.subscribe(goal.get('id'))}
              onUnsubscribe={() => goalsActions.unsubscribe(goal.get('id'))}
              goal={goal}
              isGuest={isGuest}
              currency={currency}
              type={filter.list_type}
              key={i}
              />,
          ],
        ])}
        <GoalCardWrapper style={{ visibility: 'hidden' }} />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/react/elements/GoalsPage/GoalsPage.js